import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { navMenuLinks } from './nav-bar.config';
import { UserService } from '../services/user.service';
import { NavBarModelConfig } from './models/nav-bar.model.config';
import { ConfigService } from '../services/config.service';
import { ModalService } from 'src/app/shared/components/modal/modal.service';
import { URL_PATHS } from 'src/app/shared/constants/constants';
import { CONTENT } from './util/content';
import { Privileges } from "../../shared/constants/privileges";
import { Constants, SsoApplicationType } from 'src/app/shared/constants/constants';
import { APP_CONFIG } from '../services/app-config.service';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit, OnDestroy {

  navMenu: NavBarModelConfig[] = navMenuLinks;
  content = CONTENT;
  // Array to store subscriptions for cleanup on component destruction
  subscriptions: Subscription[] = [];
  spoofWindow: any;
  ifpLinkEnabled: boolean = false;

  constructor(
    public user: UserService,
    private config: ConfigService,
    private modalService: ModalService, private router: Router
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(
      this.user.isAuntheticated$
        .subscribe((isAuth: boolean) => {
          if (isAuth) {
            this.ifpLinkEnabled = APP_CONFIG.IFP_ENROLLMENT_LINK_ENABLED === 'true';
            this.config.updateConfig(this.navMenu);
            this.navMenu = this.config.configData;
          }
        })
    );
  }

  /**
   * Calls the given method
   */
  onClick(methodName: string) {
    (this as { [key: string]: any })[methodName]();
  }

  /**
   * Redirects to whyzen sso or opens a pop-up with user access levels
   */
  callWhyzenSso() {
    if (this.user.getAccessLevels.length > 1) {
      this.modalService.open('whyzen-access-modal', false);
    } else {
      window.open(URL_PATHS.WHYZEN_SSO + this.user.getAccessLevels[0], '_blank');
    }
  }

  /**
  * Redirects to provider activity splunk login
  */
  callProviderActivitySplunk() {
    window.open(APP_CONFIG.SPLUNK_AUDIT_PROVIDER_ACTIVITY_REPORT, '_blank');
  }

  /**
  * Redirects to member activity splunk login
  */
  callMemberActivitySplunk() {
    window.open(APP_CONFIG.SPLUNK_AUDIT_MEMBER_ACTIVITY_REPORT, '_blank');
  }

  /**
  * Redirects to employer activity splunk login
  */
  callEmployerActivitySplunk() {
    window.open(APP_CONFIG.SPLUNK_AUDIT_EMPLOYER_ACTIVITY_REPORT, '_blank');
  }

  /**
  * Redirects to prospect activity splunk login
  */
  callProspectActivitySplunk() {
    window.open(APP_CONFIG.SPLUNK_AUDIT_PROSPECT_ACTIVITY_REPORT, '_blank');
  }

  /**
   * Method to route to spoof screen
   */
  spoofBrokerConnection(userName: string) {
    // if (userRole === 'BROKER') {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([Constants.SSO_REDIRECTION_FULL_PATH], {
        queryParams: {
          sso: SsoApplicationType.PRODUCER,
          spoofId: '1234',
          username: userName
        }
      })
    );
    // Logout the previous spoofed user and login with new spoof user
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        const xhr2 = new XMLHttpRequest();
        xhr2.onreadystatechange = () => {
          if (xhr2.readyState === 4) {
            let spoofWindow = window.open(APP_CONFIG.DOMAIN + '/bwa/spoof/pa/oidc/logout', 'mywindow');
            spoofWindow?.close();
            spoofWindow = window.open(url, 'mywindow');
          }
        };
        xhr2.open('GET', APP_CONFIG.DOMAIN + '/bwa/pf/idp/startSLO.ping', true);
        xhr2.send();
      }
    };
    xhr.open('GET', APP_CONFIG.DOMAIN + '/pa/oidc/logout', true);
    xhr.send();
  }

  // Method to unsubscribe from subscriptions on component destruction
  ngOnDestroy(): void {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

}
